// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lHTMi","content":"styles_content__1_0Kc"};